var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "columns" }, [
        _vm._m(0),
        _vm.assessments.length > 0 && _vm.isLoadingInvoice
          ? _c("div", { staticClass: "section" }, [
              _c("span", {
                staticClass: "is-loading-image has-text-grey has-text-centered",
              }),
            ])
          : _vm._e(),
        _vm.assessments.length > 0 && !_vm.isLoadingInvoice
          ? _c(
              "div",
              {
                staticClass:
                  "column is-flex is-justify-content-flex-end is-gap-2",
              },
              [
                _vm.isMergeMode
                  ? _c(
                      "button",
                      {
                        staticClass: "button is-info",
                        attrs: {
                          disabled:
                            !_vm.invoice ||
                            !_vm.invoice.assetId ||
                            (_vm.gstInvoice ? !_vm.gstInvoice.assetId : false),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.mergeToExisting()
                          },
                        },
                      },
                      [_vm._m(1), _c("span", [_vm._v("Merge to Existing")])]
                    )
                  : _vm._e(),
                _c(
                  "button",
                  {
                    staticClass: "button is-info",
                    attrs: {
                      disabled:
                        !_vm.invoice ||
                        !_vm.invoice.assetId ||
                        (_vm.gstInvoice ? !_vm.gstInvoice.assetId : false),
                    },
                    on: {
                      click: function ($event) {
                        _vm.isMergeMode
                          ? _vm.forceRaiseInvoice()
                          : _vm.raiseInvoice()
                      },
                    },
                  },
                  [_vm._m(2), _c("span", [_vm._v("Raise Invoice")])]
                ),
              ]
            )
          : _vm._e(),
      ]),
      _c("div", { staticClass: "is-divider mt-0 mb-4" }),
      _vm.invoice && !_vm.isLoadingInvoice
        ? _c("div", [
            _c("div", { staticClass: "columns" }, [
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Invoice No."),
                  ]),
                  _c("div", { staticClass: "field has-addons" }, [
                    _c("div", { staticClass: "control" }, [
                      _c("input", {
                        staticClass: "input is-static",
                        attrs: {
                          type: "text",
                          placeholder: "Invoice No.",
                          readonly: "",
                        },
                        domProps: { value: _vm.invoiceNoReference },
                      }),
                    ]),
                    (_vm.$userInfo.isSupportUser ||
                      _vm.$userInfo.isCustomerAdministrator) &&
                    !_vm.isMergeMode
                      ? _c("div", { staticClass: "control" }, [
                          !_vm.selectedInvoice
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "button is-warning is-inverted tooltip is-tooltip-warning",
                                  attrs: {
                                    "data-tooltip": "Change invoice no.",
                                  },
                                  on: { click: _vm.showChangeInvoiceNoModal },
                                },
                                [_vm._m(3)]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "column" }, [
                _vm.selectedInvoice
                  ? _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Invoice Date"),
                      ]),
                      _c("input", {
                        staticClass: "input is-static",
                        attrs: { readonly: "" },
                        domProps: {
                          value: _vm.$filters.formatDateTimezone(
                            _vm.invoice.invoiceDate,
                            _vm.$userInfo.locale
                          ),
                        },
                      }),
                    ])
                  : _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Invoice Date"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "control" },
                        [
                          _c("v-date-picker", {
                            attrs: {
                              "is-dark": _vm.$theme.isDark,
                              masks: _vm.formats,
                              attributes: _vm.attrs,
                              locale: _vm.$userInfo.locale,
                              "min-date": _vm.firstDayOfMonth,
                              timezone: _vm.$filters.getIanaTimezone(),
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ inputValue, inputEvents }) {
                                    return [
                                      _c("div", { staticClass: "field" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "control has-icons-left",
                                          },
                                          [
                                            _c(
                                              "input",
                                              _vm._g(
                                                {
                                                  staticClass: "input",
                                                  attrs: {
                                                    type: "text",
                                                    placeholder: "Invoice Date",
                                                    readonly: "",
                                                  },
                                                  domProps: {
                                                    value: inputValue,
                                                  },
                                                },
                                                inputEvents
                                              )
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "icon is-small is-left",
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "mdi mdi-calendar mdi-18px",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1467311795
                            ),
                            model: {
                              value: _vm.selectedInvoiceDate,
                              callback: function ($$v) {
                                _vm.selectedInvoiceDate = $$v
                              },
                              expression: "selectedInvoiceDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
              ]),
            ]),
            _c("div", { staticClass: "is-divider mt-0 mb-4" }),
            _vm.selectedInvoice
              ? _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Payer")]),
                  _c("input", {
                    staticClass: "input is-static",
                    attrs: { type: "text", readonly: "" },
                    domProps: { value: _vm.invoice.assetName },
                  }),
                ])
              : _c("div", { staticClass: "field" }, [
                  _vm.invoice.invoicePayingType ===
                  _vm.invoicePayerTypes.ThirdParty
                    ? _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("payer-selector", {
                            on: { "payer-select": _vm.onThirdPartyPayerSelect },
                            model: {
                              value: _vm.innerValue,
                              callback: function ($$v) {
                                _vm.innerValue = $$v
                              },
                              expression: "innerValue",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "control" }, [
                    _vm.invoice.invoicePayingType !==
                    _vm.invoicePayerTypes.ThirdParty
                      ? _c("label", { staticClass: "label" }, [_vm._v("Payer")])
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "pretty p-default p-round p-smooth mr-6" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.invoice.invoicePayingType,
                              expression: "invoice.invoicePayingType",
                            },
                          ],
                          attrs: { name: "rd-payerType1", type: "radio" },
                          domProps: {
                            value: _vm.invoicePayerTypes.Insurer,
                            checked: _vm._q(
                              _vm.invoice.invoicePayingType,
                              _vm.invoicePayerTypes.Insurer
                            ),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onInvoicePayerTypeClick(
                                _vm.invoicePayerTypes.Insurer
                              )
                            },
                            change: function ($event) {
                              return _vm.$set(
                                _vm.invoice,
                                "invoicePayingType",
                                _vm.invoicePayerTypes.Insurer
                              )
                            },
                          },
                        }),
                        _vm._m(4),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "pretty p-default p-round p-smooth mr-6" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.invoice.invoicePayingType,
                              expression: "invoice.invoicePayingType",
                            },
                          ],
                          attrs: {
                            name: "rd-payerType2",
                            disabled: !_vm.customerAsset,
                            type: "radio",
                          },
                          domProps: {
                            value: _vm.invoicePayerTypes.Private,
                            checked: _vm._q(
                              _vm.invoice.invoicePayingType,
                              _vm.invoicePayerTypes.Private
                            ),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onInvoicePayerTypeClick(
                                _vm.invoicePayerTypes.Private
                              )
                            },
                            change: function ($event) {
                              return _vm.$set(
                                _vm.invoice,
                                "invoicePayingType",
                                _vm.invoicePayerTypes.Private
                              )
                            },
                          },
                        }),
                        _vm._m(5),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "pretty p-default p-round p-smooth mr-6" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.invoice.invoicePayingType,
                              expression: "invoice.invoicePayingType",
                            },
                          ],
                          attrs: { name: "rd-payerType2", type: "radio" },
                          domProps: {
                            value: _vm.invoicePayerTypes.ThirdParty,
                            checked: _vm._q(
                              _vm.invoice.invoicePayingType,
                              _vm.invoicePayerTypes.ThirdParty
                            ),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onInvoicePayerTypeClick(
                                _vm.invoicePayerTypes.ThirdParty
                              )
                            },
                            change: function ($event) {
                              return _vm.$set(
                                _vm.invoice,
                                "invoicePayingType",
                                _vm.invoicePayerTypes.ThirdParty
                              )
                            },
                          },
                        }),
                        _vm._m(6),
                      ]
                    ),
                  ]),
                  !_vm.customerAsset
                    ? _c("span", { staticClass: "help is-danger" }, [
                        _vm._v(
                          "Private invoice disabled. Customer has been deleted"
                        ),
                      ])
                    : _vm._e(),
                ]),
            _c("div", { staticClass: "is-divider mt-0 mb-4" }),
            _vm.isMainInvoice
              ? _c("div", [
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "is-flex is-justify-content-space-between",
                            },
                            [
                              _c("label", { staticClass: "label" }, [
                                _vm._v("Excess"),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "is-flex is-align-items-center is-justify-content-end mb-2",
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "pr-1 is-size-7",
                                      class: {
                                        "pretty-checkbox-label":
                                          !_vm.disableExcessWithGst,
                                      },
                                      attrs: {
                                        for: "chk-invoiceExcessWtihGst",
                                      },
                                    },
                                    [_vm._v("Excess with GST")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "pretty p-icon p-round p-smooth m-0",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.invoice.excessWithGst,
                                            expression: "invoice.excessWithGst",
                                          },
                                        ],
                                        attrs: {
                                          id: "chk-invoiceExcessWtihGst",
                                          type: "checkbox",
                                          disabled: _vm.disableExcessWithGst,
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.invoice.excessWithGst
                                          )
                                            ? _vm._i(
                                                _vm.invoice.excessWithGst,
                                                null
                                              ) > -1
                                            : _vm.invoice.excessWithGst,
                                        },
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$a =
                                                  _vm.invoice.excessWithGst,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.invoice,
                                                      "excessWithGst",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.invoice,
                                                      "excessWithGst",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.invoice,
                                                  "excessWithGst",
                                                  $$c
                                                )
                                              }
                                            },
                                            function ($event) {
                                              return _vm.excessWithGstUpdate()
                                            },
                                          ],
                                        },
                                      }),
                                      _vm._m(7),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c("vue-numeric", {
                            staticClass: "input has-text-right",
                            attrs: {
                              "min:": 0,
                              precision: 2,
                              disabled:
                                _vm.hasExcessInvoice || _vm.selectedInvoice,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.excessValueChanged()
                              },
                              blur: function ($event) {
                                return _vm.calculateExcess()
                              },
                            },
                            model: {
                              value: _vm.invoice.excessAmount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.invoice,
                                  "excessAmount",
                                  _vm._n($$v)
                                )
                              },
                              expression: "invoice.excessAmount",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "column" },
                      [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Owner Contribution"),
                        ]),
                        _c("vue-numeric", {
                          staticClass: "input has-text-right",
                          attrs: {
                            "min:": 0,
                            precision: 2,
                            disabled: _vm.disableOwnerContribution,
                          },
                          on: {
                            input: function ($event) {
                              return _vm.updateInvoice()
                            },
                          },
                          model: {
                            value: _vm.invoice.ownerContribution,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.invoice,
                                "ownerContribution",
                                _vm._n($$v)
                              )
                            },
                            expression: "invoice.ownerContribution",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Discount"),
                          ]),
                          _c("vue-numeric", {
                            staticClass: "input has-text-right",
                            attrs: {
                              "min:": 0,
                              precision: 2,
                              disabled: _vm.selectedInvoice,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.updateInvoice()
                              },
                            },
                            model: {
                              value: _vm.invoice.quoteDiscount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.invoice,
                                  "quoteDiscount",
                                  _vm._n($$v)
                                )
                              },
                              expression: "invoice.quoteDiscount",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "field" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "is-flex is-justify-content-space-between",
                          },
                          [
                            _c("label", { staticClass: "label" }, [
                              _vm._v("GST"),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "is-flex is-align-items-center is-justify-content-end mb-2",
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "pretty-checkbox-label pr-1 is-size-7",
                                    attrs: { for: "chk-fixed-gst" },
                                  },
                                  [_vm._v("Fixed")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "pretty p-icon p-round p-smooth m-0",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.fixedGst,
                                          expression: "fixedGst",
                                        },
                                      ],
                                      attrs: {
                                        id: "chk-fixed-gst",
                                        type: "checkbox",
                                        disabled: _vm.selectedInvoice,
                                      },
                                      domProps: {
                                        checked: Array.isArray(_vm.fixedGst)
                                          ? _vm._i(_vm.fixedGst, null) > -1
                                          : _vm.fixedGst,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.fixedGst,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.fixedGst = $$a.concat([
                                                  $$v,
                                                ]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.fixedGst = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.fixedGst = $$c
                                          }
                                        },
                                      },
                                    }),
                                    _vm._m(8),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "control" },
                          [
                            _c("vue-numeric", {
                              staticClass: "input has-text-right",
                              attrs: {
                                minus: true,
                                precision: 2,
                                disabled:
                                  _vm.isGstInvoiceOn || _vm.selectedInvoice,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.updateGst()
                                },
                              },
                              model: {
                                value: _vm.invoice.gst,
                                callback: function ($$v) {
                                  _vm.$set(_vm.invoice, "gst", _vm._n($$v))
                                },
                                expression: "invoice.gst",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                ])
              : _c("div", [
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [_vm._v("GST")]),
                        _c(
                          "div",
                          { staticClass: "control" },
                          [
                            _c("vue-numeric", {
                              staticClass: "input has-text-right",
                              attrs: {
                                minus: true,
                                precision: 2,
                                disabled:
                                  _vm.isGstInvoiceOn || _vm.selectedInvoice,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.updateGst()
                                },
                              },
                              model: {
                                value: _vm.invoice.gst,
                                callback: function ($$v) {
                                  _vm.$set(_vm.invoice, "gst", _vm._n($$v))
                                },
                                expression: "invoice.gst",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "column" }),
                  ]),
                ]),
            _c("div", { staticClass: "field mt-2" }, [
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.invoice.exported,
                      expression: "invoice.exported",
                    },
                  ],
                  staticClass: "is-checkradio",
                  attrs: {
                    type: "checkbox",
                    id: "invoice-exported",
                    disabled: _vm.selectedInvoice,
                  },
                  domProps: {
                    checked: Array.isArray(_vm.invoice.exported)
                      ? _vm._i(_vm.invoice.exported, null) > -1
                      : _vm.invoice.exported,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.invoice.exported,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(_vm.invoice, "exported", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.invoice,
                              "exported",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.invoice, "exported", $$c)
                      }
                    },
                  },
                }),
                _c("label", { attrs: { for: "invoice-exported" } }, [
                  _vm._v("Exported"),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "columns has-text-right" }, [
              _vm.isMainInvoice
                ? _c("div", { staticClass: "column is-three-quarters" }, [
                    _vm._m(9),
                    _vm.invoice.quoteDiscount
                      ? _c(
                          "span",
                          { staticClass: "label has-text-weight-normal" },
                          [_vm._v("Discount")]
                        )
                      : _vm._e(),
                    _vm.invoice.excessAmount && _vm.invoice.excessWithGst
                      ? _c(
                          "span",
                          { staticClass: "label has-text-weight-normal" },
                          [_vm._v("Excess")]
                        )
                      : _vm._e(),
                    _vm.invoice.ownerContribution && _vm.invoice.excessWithGst
                      ? _c(
                          "span",
                          { staticClass: "label has-text-weight-normal" },
                          [_vm._v("Owner Cont.")]
                        )
                      : _vm._e(),
                    _c(
                      "span",
                      { staticClass: "label has-text-weight-normal" },
                      [
                        _vm._v("GST "),
                        _vm.showGstRate
                          ? _c("span", { staticClass: "subtext" }, [
                              _vm._v("(" + _vm._s(_vm.invoice.gstRate) + "%)"),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    (_vm.invoice.ownerContribution &&
                      !_vm.invoice.excessWithGst) ||
                    (_vm.invoice.excessAmount && !_vm.invoice.excessWithGst)
                      ? _c(
                          "span",
                          { staticClass: "label has-text-weight-normal" },
                          [
                            _vm._v("Total "),
                            _c("span", { staticClass: "subtext" }, [
                              _vm._v("(Inc GST)"),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm.invoice.ownerContribution && !_vm.invoice.excessWithGst
                      ? _c(
                          "span",
                          { staticClass: "label has-text-weight-normal" },
                          [
                            _vm._v("Owner Cont. "),
                            _c("span", { staticClass: "subtext" }, [
                              _vm._v("(Inc GST)"),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm.invoice.excessAmount && !_vm.invoice.excessWithGst
                      ? _c(
                          "span",
                          { staticClass: "label has-text-weight-normal" },
                          [_vm._v("Excess")]
                        )
                      : _vm._e(),
                    _vm._m(10),
                  ])
                : _c("div", { staticClass: "column is-three-quarters" }, [
                    _vm._m(11),
                    _c(
                      "span",
                      { staticClass: "label has-text-weight-normal" },
                      [
                        _vm._v("GST "),
                        _c("span", { staticClass: "subtext" }, [
                          _vm._v("(" + _vm._s(_vm.invoice.gstRate) + "%)"),
                        ]),
                      ]
                    ),
                    _vm._m(12),
                  ]),
              _vm.isMainInvoice
                ? _c("div", { staticClass: "column is-one-quarter pr-5" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "label has-text-success has-text-weight-normal",
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatCurrency(
                              _vm.selectedAssessmentsAuthorisedAmount,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]
                    ),
                    _vm.invoice.quoteDiscount
                      ? _c(
                          "span",
                          { staticClass: "label has-text-weight-normal" },
                          [
                            _vm._v(
                              "- " +
                                _vm._s(
                                  _vm.$filters.formatCurrency(
                                    _vm.invoice.quoteDiscount,
                                    _vm.$userInfo.locale
                                  )
                                )
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.invoice.excessAmount && _vm.invoice.excessWithGst
                      ? _c(
                          "span",
                          { staticClass: "label has-text-weight-normal" },
                          [
                            _vm._v(
                              "- " +
                                _vm._s(
                                  _vm.$filters.formatCurrency(
                                    _vm.invoice.excessAmount,
                                    _vm.$userInfo.locale
                                  )
                                )
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.invoice.ownerContribution && _vm.invoice.excessWithGst
                      ? _c(
                          "span",
                          { staticClass: "label has-text-weight-normal" },
                          [
                            _vm._v(
                              "- " +
                                _vm._s(
                                  _vm.$filters.formatCurrency(
                                    _vm.invoice.ownerContribution,
                                    _vm.$userInfo.locale
                                  )
                                )
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "span",
                      { staticClass: "label has-text-weight-normal" },
                      [
                        _vm.invoice.gst > 0
                          ? _c("span", [_vm._v("+")])
                          : _vm._e(),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                _vm.invoice.gst,
                                _vm.$userInfo.locale
                              )
                            )
                        ),
                      ]
                    ),
                    (_vm.invoice.ownerContribution &&
                      !_vm.invoice.excessWithGst) ||
                    (_vm.invoice.excessAmount && !_vm.invoice.excessWithGst)
                      ? _c(
                          "span",
                          { staticClass: "label has-text-weight-normal" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatCurrency(
                                  _vm.invTotalExGst + _vm.invoice.gst,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.invoice.ownerContribution && !_vm.invoice.excessWithGst
                      ? _c(
                          "span",
                          { staticClass: "label has-text-weight-normal" },
                          [
                            _vm._v(
                              "- " +
                                _vm._s(
                                  _vm.$filters.formatCurrency(
                                    _vm.invoice.ownerContribution *
                                      (_vm.invoice.gstRate / 100 + 1),
                                    _vm.$userInfo.locale
                                  )
                                )
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.invoice.excessAmount && !_vm.invoice.excessWithGst
                      ? _c(
                          "span",
                          { staticClass: "label has-text-weight-normal" },
                          [
                            _vm._v(
                              "- " +
                                _vm._s(
                                  _vm.$filters.formatCurrency(
                                    _vm.invoice.excessAmount,
                                    _vm.$userInfo.locale
                                  )
                                )
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c("span", { staticClass: "label has-text-success" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.invoice.totalIncGst,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                  ])
                : _c("div", { staticClass: "column is-one-quarter" }, [
                    _c(
                      "span",
                      { staticClass: "label has-text-weight-normal" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatCurrency(
                              _vm.invoice.totalExGst,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]
                    ),
                    _c(
                      "span",
                      { staticClass: "label has-text-weight-normal" },
                      [
                        _vm.invoice.gst > 0
                          ? _c("span", [_vm._v("+")])
                          : _vm._e(),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                _vm.invoice.gst,
                                _vm.$userInfo.locale
                              )
                            )
                        ),
                      ]
                    ),
                    _c("span", { staticClass: "label has-text-success" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.invoice.totalIncGst,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                  ]),
            ]),
            _c("div", { staticClass: "is-divider mt-0 mb-4" }),
            _vm.invoice && !_vm.isLoadingInvoice
              ? _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "is-narrow" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.isGstInvoiceOn,
                          expression: "isGstInvoiceOn",
                        },
                      ],
                      staticClass: "is-checkradio",
                      attrs: {
                        type: "checkbox",
                        id: `gstInvoice`,
                        disabled: _vm.selectedInvoice,
                      },
                      domProps: {
                        checked: Array.isArray(_vm.isGstInvoiceOn)
                          ? _vm._i(_vm.isGstInvoiceOn, null) > -1
                          : _vm.isGstInvoiceOn,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.addRemoveGstInvoice($event.target.checked)
                        },
                        change: function ($event) {
                          var $$a = _vm.isGstInvoiceOn,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.isGstInvoiceOn = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.isGstInvoiceOn = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.isGstInvoiceOn = $$c
                          }
                        },
                      },
                    }),
                    _c("label", { attrs: { for: `gstInvoice` } }, [
                      _vm._v("GST Invoice"),
                    ]),
                  ]),
                  _vm.gstInvoice
                    ? _c("div", { staticClass: "mt-2" }, [
                        _vm.selectedInvoice
                          ? _c("div", [
                              _c("label", { staticClass: "label" }, [
                                _vm._v("Payer"),
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.gstInvoice.assetName)),
                              ]),
                              _c("div", { staticClass: "field" }, [
                                _c("div", { staticClass: "control" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.gstInvoice.exported,
                                        expression: "gstInvoice.exported",
                                      },
                                    ],
                                    staticClass: "is-checkradio",
                                    attrs: {
                                      type: "checkbox",
                                      id: "gstInvoice-exported",
                                      disabled:
                                        _vm.selectedInvoice ||
                                        !_vm.$userInfo.isSupportUser,
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.gstInvoice.exported
                                      )
                                        ? _vm._i(
                                            _vm.gstInvoice.exported,
                                            null
                                          ) > -1
                                        : _vm.gstInvoice.exported,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.gstInvoice.exported,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.gstInvoice,
                                                "exported",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.gstInvoice,
                                                "exported",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.gstInvoice,
                                            "exported",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _c(
                                    "label",
                                    { attrs: { for: "gstInvoice-exported" } },
                                    [_vm._v("Exported")]
                                  ),
                                ]),
                              ]),
                            ])
                          : _c("div", [
                              _c(
                                "div",
                                { staticClass: "field" },
                                [
                                  _c("payer-selector", {
                                    on: {
                                      "payer-select": _vm.onGstInvPayerSelect,
                                    },
                                    model: {
                                      value: _vm.innerValue,
                                      callback: function ($$v) {
                                        _vm.innerValue = $$v
                                      },
                                      expression: "innerValue",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "field mt-2" }, [
                                _c("div", { staticClass: "control" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.gstInvoice.exported,
                                        expression: "gstInvoice.exported",
                                      },
                                    ],
                                    staticClass: "is-checkradio",
                                    attrs: {
                                      type: "checkbox",
                                      id: "gst-invoice-exported",
                                      disabled: !_vm.$userInfo.isSupportUser,
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.gstInvoice.exported
                                      )
                                        ? _vm._i(
                                            _vm.gstInvoice.exported,
                                            null
                                          ) > -1
                                        : _vm.gstInvoice.exported,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.gstInvoice.exported,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.gstInvoice,
                                                "exported",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.gstInvoice,
                                                "exported",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.gstInvoice,
                                            "exported",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _c(
                                    "label",
                                    { attrs: { for: "gst-invoice-exported" } },
                                    [_vm._v("Exported")]
                                  ),
                                ]),
                              ]),
                            ]),
                        _c("div", { staticClass: "is-divider mt-3 mb-4" }),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            false
              ? _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.isOverrideEnabled,
                          expression: "isOverrideEnabled",
                        },
                      ],
                      staticClass: "is-checkradio",
                      attrs: {
                        type: "checkbox",
                        disabled: _vm.selectedInvoice,
                        id: "override",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.isOverrideEnabled)
                          ? _vm._i(_vm.isOverrideEnabled, null) > -1
                          : _vm.isOverrideEnabled,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.isOverrideEnabled,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.isOverrideEnabled = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.isOverrideEnabled = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.isOverrideEnabled = $$c
                          }
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "override" } }, [
                      _vm._v("Enable Override"),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.isOverrideEnabled
              ? _c("div", [
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Total Labour"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "control" },
                          [
                            _c("vue-numeric", {
                              staticClass: "input has-text-right",
                              attrs: {
                                "min:": 0,
                                disabled: _vm.selectedInvoice,
                                precision: 2,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.onLabourOverrideChange()
                                },
                              },
                              model: {
                                value: _vm.invoice.labourOverride,
                                callback: function ($$v) {
                                  _vm.$set(_vm.invoice, "labourOverride", $$v)
                                },
                                expression: "invoice.labourOverride",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("R & R"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "control" },
                          [
                            _c("vue-numeric", {
                              staticClass: "input has-text-right",
                              attrs: {
                                "min:": 0,
                                disabled: _vm.selectedInvoice,
                                precision: 2,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.onOverrideChange()
                                },
                              },
                              model: {
                                value: _vm.invoice.rrOverride,
                                callback: function ($$v) {
                                  _vm.$set(_vm.invoice, "rrOverride", $$v)
                                },
                                expression: "invoice.rrOverride",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Repair"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "control" },
                          [
                            _c("vue-numeric", {
                              staticClass: "input has-text-right",
                              attrs: {
                                "min:": 0,
                                disabled: _vm.selectedInvoice,
                                precision: 2,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.onOverrideChange()
                                },
                              },
                              model: {
                                value: _vm.invoice.repairOverride,
                                callback: function ($$v) {
                                  _vm.$set(_vm.invoice, "repairOverride", $$v)
                                },
                                expression: "invoice.repairOverride",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Paint"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "control" },
                          [
                            _c("vue-numeric", {
                              staticClass: "input has-text-right",
                              attrs: {
                                "min:": 0,
                                disabled: _vm.selectedInvoice,
                                precision: 2,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.onOverrideChange()
                                },
                              },
                              model: {
                                value: _vm.invoice.paintOverride,
                                callback: function ($$v) {
                                  _vm.$set(_vm.invoice, "paintOverride", $$v)
                                },
                                expression: "invoice.paintOverride",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [_vm._v("Mech")]),
                        _c(
                          "div",
                          { staticClass: "control" },
                          [
                            _c("vue-numeric", {
                              staticClass: "input has-text-right",
                              attrs: {
                                "min:": 0,
                                disabled: _vm.selectedInvoice,
                                precision: 2,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.onOverrideChange()
                                },
                              },
                              model: {
                                value: _vm.invoice.mechOverride,
                                callback: function ($$v) {
                                  _vm.$set(_vm.invoice, "mechOverride", $$v)
                                },
                                expression: "invoice.mechOverride",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _c("div", { staticClass: "is-divider mt-4 mb-2" }),
      _c("div", { staticClass: "mb-4" }, [
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "field mt-2" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Remarks")]),
              _c("div", { staticClass: "control" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.invoice.invoiceRemark,
                      expression: "invoice.invoiceRemark",
                    },
                  ],
                  staticClass: "textarea",
                  attrs: {
                    placeholder: "Remarks",
                    disabled: _vm.selectedInvoice,
                  },
                  domProps: { value: _vm.invoice.invoiceRemark },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.invoice,
                        "invoiceRemark",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm.isInvoiceNoSearchModalActive
        ? _c("invoice-no-search-modal", {
            attrs: {
              active: _vm.isInvoiceNoSearchModalActive,
              "invoice-type": 1,
            },
            on: {
              "update:active": function ($event) {
                _vm.isInvoiceNoSearchModalActive = $event
              },
              ok: _vm.changeInvoiceNo,
              close: function ($event) {
                _vm.isInvoiceNoSearchModalActive = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column is-flex is-align-items-center" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Invoice Control")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-merge mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-playlist-check mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-medium" }, [
      _c("i", { staticClass: "mdi mdi-pencil-outline mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary-o" }, [
      _c("label", [_vm._v("Insurer")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary-o" }, [
      _c("label", [_vm._v("Private")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary-o" }, [
      _c("label", [_vm._v("3rd Party")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "label has-text-weight-normal" }, [
      _vm._v("Total "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Ex GST)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "label" }, [
      _vm._v("Total Payable "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Inc GST)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "label has-text-weight-normal" }, [
      _vm._v("Total "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Ex GST)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "label" }, [
      _vm._v("Total Payable "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Inc GST)")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }